import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const SummaryCard = ({ summaryData }) => {
  return (
    <MDBox sx={{ mt: 3 }}>
      <MDBox
        sx={{
          mt: 2,
          borderRadius: 2,
          border: "1px solid #e0e0e0",
          backgroundColor: "#fafafa",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          p: 0,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxWidth: { md: 480 },
        }}
      >
        {/* Header */}
        <MDBox
          sx={{
            background: "linear-gradient(90deg, #057ddeff 0%, #60d2dfff 100%)",
            color: "#fff",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            px: 2,
            py: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Icon sx={{ fontSize: 32 }}>summarize</Icon>
          <MDTypography variant="h5" fontWeight="bold" color="white">
            Summary
          </MDTypography>
        </MDBox>

        {/* Summary Row */}
        <SummaryRow label="Total Animals :" value={summaryData.total_count} />
        {/* <SummaryRow label="Final Total Price :" value={summaryData.total_price} />
        <SummaryRow label="Avg. Animal Price :" value={summaryData.avg_price} /> */}

        {/* Gender-wise Table */}
        <MDBox
          sx={{
            mt: 0,
            px: 2,
            py: 1,
            overflowX: "auto",
            backgroundColor: "#fff",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "0.8rem",
              textAlign: "center",
            }}
          >
            <thead style={{ backgroundColor: "#f5f5f5" }}>
              <tr>
                <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: 600 }}>Gender</th>
                <th style={{ padding: "6px 8px", fontWeight: 600 }}>Count</th>
                <th style={{ padding: "6px 8px", fontWeight: 600, textAlign: "right" }}>Total Price</th>
                <th style={{ padding: "6px 8px", fontWeight: 600, textAlign: "right" }}>Avg. Price Each</th>
              </tr>
            </thead>
            <tbody>
              {summaryData.gender_stats?.map(
                (item, idx) =>
                  item.count > 0 && (
                    <tr key={idx}>
                      <td style={{ padding: "6px 8px", textAlign: "left" }}>{item.label}</td>
                      <td>{item.count}</td>
                      <td style={{ color: "#1976d2", textAlign: "right" }}>{item.price}</td>
                      <td style={{ color: "#da08c2ff", textAlign: "right" }}>{item.avg_price}</td>
                    </tr>
                  )
              )}
            </tbody>
          </table>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

const SummaryRow = ({ label, value }) => (
  <MDBox
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: { xs: "row", sm: "row" },
      borderBottom: "1px dashed #e0e0e0",
      px: 2,
      py: 1,
    }}
  >
    <MDTypography
      variant="body2"
      color="text.secondary"
      fontWeight="bold"
      sx={{
        fontSize: "0.9rem",
        width: { sm: "180px" },
      }}
    >
      {label}
    </MDTypography>

    <MDTypography
      variant="body1"
      color="text.primary"
      sx={{
        fontSize: "1rem",
        backgroundColor: "#fff",
        borderRadius: 1,
        px: 1.2,
        minWidth: "80px",
        textAlign: "right",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      {value}
    </MDTypography>
  </MDBox>
);

export default SummaryCard;
